// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"440":"b4874552","710":"2bdda252","837":"c4b44351"}[chunkId] + ".chunk.css";
};